import { useRouter } from "next/router";

import { getInboxTeamIdFromQuery, resolveInboxTeamId } from "~/hooks/inbox/resolveInboxTeamId";
import { useTeamById } from "~/hooks/person-group/useTeamById";

export const useInboxTeamId = (storedTeamId: string): string => {
  const router = useRouter();
  const queryTeamId = getInboxTeamIdFromQuery(router.query);
  const { isSuccess, data } = useTeamById(queryTeamId);

  // Only a lookup that came back empty proves the id names nothing. Still loading, errored, or
  // refused for a missing personGroup.read all leave isSuccess false and must keep the URL's team —
  // reading those as "unknown" would drop every good link back to storage on first render.
  const isUnknownTeam = isSuccess && (!data || data.deletedAt !== null);

  return resolveInboxTeamId(queryTeamId, storedTeamId, isUnknownTeam);
};
